import React from 'react';
import { PapiUser } from '@wix/da-papi-types';
import PublishedTime from '../../_partials/PublishedTime';
import UserAvatar from '../../../User/Avatar/UserAvatar';
import UserLink from '../../../User/Link/UserLink';
import s from './UserInfoBlock.scss';

interface Props {
  user: PapiUser;
  publishedTime?: string;
}

const UserInfoBlock: React.FC<Props> = ({ user, publishedTime }) => (
  <div className={s['root']}>
    <UserAvatar size={32} user={user} className={s['author-avatar']} />
    <span className={s['author-username']}>
      <UserLink user={user} className={s['author-userlink']} />
      {publishedTime && (
        <PublishedTime
          publishedTime={publishedTime}
          withoutText
        />
      )}
    </span>
  </div>
);
UserInfoBlock.displayName = 'UserInfoBlock';

export default UserInfoBlock;
